// @spec BCP-STR-050
import { createFileRoute } from '@tanstack/react-router';

import { Iso22301ComplianceReport } from '@/features/bcp/components/Iso22301ComplianceReport';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/reports/iso-22301')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.iso22301ComplianceReport'),
  }),
  component: Iso22301ComplianceReportPage,
});

function Iso22301ComplianceReportPage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <Iso22301ComplianceReport />
      </div>
    </div>
  );
}
